export default __webpack_public_path__ + "static/media/image-1-1-placeholder.c1606645.svg";